import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { getSalaryRowLevelValue } from '../api/salary-table-operations.js';
import { allSalaryTableLevels, type SalaryTableLevels } from '../enum/SalaryTableLevels.js';
import type { SalaryTableCol, SalaryTableRow } from '../enum/SalaryTableRow.js';
import type { SalaryTableRowKeys } from '../enum/SalaryTableRowKeys.js';

@Entity()
export class SalaryTable extends MongoEntity {
  static override _class = 'SalaryTable';
  static override _collectionName = 'salary-tables';

  constructor(doc: PartialEntityData<SalaryTable>) {
    super(doc);
  }

  @validate(nonOptional())
  @Field(type => String)
  public key: Maybe<SalaryTableRowKeys>;

  @validate(() => {})
  @Field(type => [Float])
  public levels: Maybe<SalaryTableRow>;

  public getLevelValue(targetLevel: SalaryTableLevels | number): SalaryTableCol | undefined {
    if (typeof targetLevel === 'number') targetLevel = allSalaryTableLevels()[targetLevel - 1]!;

    return getSalaryRowLevelValue(this.levels, targetLevel);
  }
}
